module.exports = __webpack_public_path__ + "img/horizontal_4_4_r_pp2_8019.a4c82e8c.png";